import { useLocalSearchParams } from "expo-router";
import { useMemo } from "react";
import { JournalForm } from "~/components/form/journal/JournalForm";
import { Dismiss } from "~/components/permission/Dismiss";
import { useDismiss } from "~/providers/DismissProvider";
import { useJournal } from "~/providers/JournalProvider";
import { useTrackable } from "~/providers/TrackableProvider";

export default function CreateJournal() {
    const { id, date } = useLocalSearchParams<{ id: string; date?: string }>();
    const { handleDismiss } = useDismiss();
    const { findTrackable } = useTrackable();
    const { canUpdateJournal } = useJournal();

    const type = useMemo(() => findTrackable(id), [findTrackable, id]);

    if (!type?.id || !canUpdateJournal(type.type)) {
        return <Dismiss />;
    }

    return <JournalForm onRequestClose={handleDismiss} type={type} onDate={date} asRoute />;
}
